export default "__VITE_PUBLIC_ASSET__d4bac458__"